import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from "@mui/material";
import { Close, Delete, PictureAsPdf } from "@mui/icons-material";
import dayjs from "dayjs";

interface DeleteResultsDialogProps {
  open: boolean;
  onClose: () => void;
  resultUrls?: string[];
  resultToDelete?: string;
  onDeleteResult: (url?: string) => Promise<void>;
}

export function DeleteResultsDialog({
  open,
  onClose,
  resultUrls = [],
  resultToDelete,
  onDeleteResult,
}: DeleteResultsDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="delete-dialog-title">
        Remover Resultados
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {resultToDelete ? (
          <DialogContentText id="delete-dialog-description">
            Tem certeza que deseja remover este resultado?
          </DialogContentText>
        ) : resultUrls?.length > 0 ? (
          <>
            <DialogContentText id="delete-dialog-description" sx={{ mb: 2 }}>
              Selecione os resultados que deseja remover:
            </DialogContentText>
            <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
              {resultUrls.map((url: string, index: number) => (
                <Box key={index}>
                  <ListItem>
                    <ListItemIcon>
                      <PictureAsPdf />
                    </ListItemIcon>
                    <ListItemText 
                      primary={`Resultado ${index + 1}`} 
                      secondary={`Enviado em ${dayjs().format('DD/MM/YYYY')}`}
                    />
                    <ListItemSecondaryAction>
                      <IconButton 
                        edge="end" 
                        aria-label="excluir"
                        onClick={async () => {
                          await onDeleteResult(url);
                        }}
                        color="error"
                      >
                        <Delete fontSize="small" />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                  {index < resultUrls.length - 1 && <Divider variant="inset" component="li" />}
                </Box>
              ))}
            </List>
          </>
        ) : (
          <Typography>Nenhum resultado disponível para remoção.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancelar
        </Button>
        {!resultToDelete && resultUrls?.length > 1 && (
          <Button 
            onClick={async () => {
              await onDeleteResult();
            }} 
            color="error" 
            variant="contained"
          >
            Remover Todos
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
